import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiError, apiFetch } from 'API/apiClient';
import type { IPrize } from 'types/IPrize';
import type { RootState } from 'store/store';

export const fetchPrizes = createAsyncThunk<IPrize[], number | undefined, { rejectValue: ApiError; state: RootState }>('prizes/fetchAll', async (drawingBaseId, { rejectWithValue }) => {
  const url = drawingBaseId ? `/prize?drawingBaseId=${drawingBaseId}` : '/prize';
  return await apiFetch<IPrize[]>(url, {}, rejectWithValue);
});

export const createPrize = createAsyncThunk<IPrize, Partial<IPrize>, { rejectValue: ApiError; state: RootState }>('prizes/create', async (data, { rejectWithValue }) => {
  return await apiFetch<IPrize>('/prize', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }, rejectWithValue);
});

export const updatePrize = createAsyncThunk<IPrize, { id: number; data: Partial<IPrize> }, { rejectValue: ApiError; state: RootState }>('prizes/update', async ({ id, data }, { rejectWithValue }) => {
  return await apiFetch<IPrize>(`/prize/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }, rejectWithValue);
});

export const deletePrize = createAsyncThunk<void, number, { rejectValue: ApiError; state: RootState }>('prizes/delete', async (id, { rejectWithValue }) => {
  return await apiFetch<void>(`/prize/${id}`, { method: 'DELETE' }, rejectWithValue);
});
